export const auctionHeaderStyle = {
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
	},

	wrapperHeader: {
		background: 'var(--default-white)',
		borderRadius: '8px',
		padding: '16px 24px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		boxShadow: 'var(--box-shadow--2)',

		'@media (max-width: 1023.98px)': {
			flexDirection: 'column',
			gap: '10px',
		},

		'@media (max-width: 639.98px)': {
			margin: '0px 20px',
		},
	},

	wrapperList: {
		background: 'var(--default-white)',
		borderRadius: '8px',
		padding: '24px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		height: '100%',
		boxShadow: 'var(--box-shadow--2)',
	},

	data: {
		fontWeight: 'bold',
	},

	time: {
		display: 'flex',
		alignItems: 'center',
		gap: '16px',
	},

	alignWrapper: {
		fontWeight: '400',
		display: 'flex',
		alignItems: 'center',
		gap: '4px',

		svg: {
			width: '16px',
			height: '16px',
		},
	},

	headerItem: {
		display: 'flex',
		gap: '24px',
	},

	icon: {
		svg: {
			path: {
				fill: 'var(--neutral-200)',
			},
		},

		'@media (max-width: 1023.98px)': {
			display: 'none',
		},
	},

	search: {
		position: 'relative',
		marginBottom: '24px',

		svg: {
			position: 'absolute',
			left: '10px',
			top: '8px',
		},

		'& .MuiFormControl-root .MuiInputBase-root input': {
			paddingLeft: '40px',

			'&::placeholder': {
				color: 'var(--neutral-500)',
			},
		},
		'& .MuiFormControl-root .MuiInputBase-root fieldset': {
			border: 0,
			background: 'var(--background-grey-op-50-1)',
		},
	},
};
